import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { nutrimaticLabels } from '@/nutrimatic'

export type LiquidityNutrimaticVariant = 'mobile' | 'desktop-tablet'

/** Vuelve al hub de posiciones LP desde la bahía operativa en tableta desktop. */
export function useLiquidityHubTabletBack() {
  const navigate = useNavigate()
  return useCallback(() => navigate('/pool'), [navigate])
}

/** Props de cabecera Nutrimatic según variante (móvil vs tableta desktop del hub). */
export function liquidityNutrimaticTabletHeaderProps(
  variant: LiquidityNutrimaticVariant,
  backToPositions: () => void,
  overrides?: {
    onBack?: () => void
    backLabel?: string
    hideBack?: boolean
    hideTrailing?: boolean
    showBrand?: boolean
  },
) {
  const isDesktopTablet = variant === 'desktop-tablet'

  if (!isDesktopTablet) {
    return {
      hideBack: false,
      hideTrailing: false,
      showBrand: true,
      ...overrides,
    }
  }

  return {
    onBack: overrides?.onBack ?? backToPositions,
    backLabel: overrides?.backLabel ?? nutrimaticLabels.liquidityHub.backToPositions,
    hideBack: overrides?.hideBack ?? false,
    hideTrailing: overrides?.hideTrailing ?? true,
    showBrand: overrides?.showBrand ?? false,
    ...overrides,
  }
}
